/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Delete_StageInputs */

const cs_pipelines_delete_stage = /** @type {(inputs: Pipelines_Delete_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat fázi`)
};

const en_pipelines_delete_stage = /** @type {(inputs: Pipelines_Delete_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete stage`)
};

/**
* | output |
* | --- |
* | "Delete stage" |
*
* @param {Pipelines_Delete_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_delete_stage = /** @type {((inputs?: Pipelines_Delete_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Delete_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_delete_stage(inputs)
	return cs_pipelines_delete_stage(inputs)
});